import { Header, Footer } from "../../../../../../components";
import { PostEditor } from "../../../../../../modules/PostEditor";

export const LectureInquiryEdit = () => {
  return (
    <>
      <Header />
      <PostEditor />
      <Footer />
    </>
  );
};
